/* eslint-disable no-console */
/* eslint-disable no-async-promise-executor */
import axios from 'axios';
import Qs from 'qs'
// eslint-disable-next-line import/first
import $catch from './$catch';
import $public from './$public';
import $loginOut from './$login-out';
import CONFIG from '@/config';
const FileSaver = require("file-saver");

/**
 * $http请求出口（带token验证）
 * @params: method<String>  请求类型GET / POST / PUT / DELETE...
 * @params: url<String>  请求路径
 * @params: data<Object>  请求体数据
 * @params: params<Object>  请求参数，显示在url上
 *
 * @params: options<Object>  配置参数
 *          isLoading<Boolean> 是否有加载层显示，默认为：true
 *          isBackCode<Boolean> 如果接口有错误码，是否连同错误码一起返回，默认为：false
 *          headers<Object> 自定义请求头信息，会以merge合并
 *          request<Object> 请求体里的其它配置项，如timeout、responseType等
 *          isClearParam<Boolean> 是否清空参数里的空值，默认为：false
 *          isFormData<Boolean> 是否格式化body里的数据，默认为：false
 */
export const $http = (method, url, data = {}, params = {}, options = {}) => {
    //初始验证
    if (!method || !url) {
        return new Error('Missing request parameters!');
    }
    //判断是否有登录平台
    // if (!$catch.isLogin()) {
    //     //退出到平台登录界面
    //     $loginOut.loginOutHref();
    //     return Promise.resolve(null);
    // }

    /**
     * 参数整理
     */
    //清除空格
    if (options.isClearSpace) {
        if (!$public.isEmpty(data)) data = $public.clearSpace(data);
        if (!$public.isEmpty(params)) params = $public.clearSpace(params);
    }

    //是否清空参数里的空值
    if (options.isClearParam) {
        if (!$public.isEmpty(data)) data = $public.clearParamVal(data);
        if (!$public.isEmpty(params)) params = $public.clearParamVal(params);
    }

    //是否格式化body里的数据 当以put传参时用 会转换为formData键值对的方式
    if (options.isFormData) {
        if (!$public.isEmpty(data)) data = $public.jsonToParams(data);
    }
    // eslint-disable-next-line eqeqeq
    // if (method == 'GET') {
    //     for (let key in params) {
    //         params[key] = encodeURIComponent(params[key])
    //     }
    // }
    /**
     * 请求对像params格式化
     */
    const _request = options.request || {}; //请求体里的其它配置参数
    const _params = {
        url,
        data,
        params,
        method: method || 'GET',
        ..._request
    };

    //请求数据
    return $https(_params, options);
};


/**
 * $https请求出口（不带token验证）
 * @params: params<Object>  请求参数
 *          method<String>  请求类型GET / POST / PUT / DELETE...
 *          url<String>  请求路径
 *          data<Object>  请求体数据
 *          ...其它请求体里的配置项(header、timeout、responseType)
 *
 * @params: options<Object>  配置参数
 *          isLoading<Boolean> 是否有加载层显示，默认为：true
 *          isBackCode<Boolean> 如果接口有错误码，是否连同错误码一起返回，默认为：false
 *          headers<Object> 自定义请求头信息，会以merge合并
 *          isMessage<Boolean> 是否进行错误提示，默认为：true
 *          isExport<Boolean> 是否是导出文件请求，默认为：false (需要配置responseType 为 blob才会生效)
 */
export const $https = (params = {}, options = {}) => {

    //配置参数初始化
    options = { isLoading: true, isMessage: true, ...options };
    //显示加载层
    if (options.isLoading) $public.loading(true);

    //获取header
    const _header = Object.assign({}, $catch.getHeaders(), options.headers);
    const _url = /^http:/.test(params.url) ? params.url : CONFIG.api + params.url;
    // 整理头
    const _method = params.method || 'GET';
    const _params = Object.assign({}, {
        data: params.data,
        headers: _header,
        params: params.params,
        method: _method.toUpperCase(),
        paramsSerializer:(params)=>{
            return Qs.stringify(params, {arrayFormat: 'brackets'})
        }
    }, params, { url: _url });
    console.log(3,_params)
    return new Promise((resolve) => {
        axios
            .request(_params)
            .then(res => {
                if(res.headers.refreshtoken){
                    //更新token
                    $catch.setSessionItem(CONFIG.headers[0], res.headers.refreshtoken);
                }

                if (options.isLoading) $public.loading(false);
                if (res.status === 200) {
                    if (res.data.code === 200) {
                        //请求成功, 返回结果
                        return resolve(options.isBackCode ? res.data : res.data.data);
                    } else {
                        // 服务器错误处理
                        if (options.isBackCode) {
                            //会返回错误码等内容， 作特殊提示位置处理
                            //文件导出时，必须返回 res.data
                            if (options.isExport && _params.responseType === 'blob') {
                                //如果是数据导出，进行特殊处理
                                const _st = exportFile(res); //导出数据
                                if (_st) return resolve(true);
                            }
                            //说明： 如果是导出，header里没有文件名，会直接返回数据包，需自己处理导出方法
                            return resolve(res.data);
                        }
                        if (options.isMessage) $public.message(res.data.message || res.data.msg, 'error');
                        return resolve(null);
                    }

                } else if (res.status === 401) {
                    //退出到平台登录界面
                    // eslint-disable-next-line no-restricted-globals
                    if (location.hash.indexOf('#/login') >= 0 || location.hash === '#/') {
                        //登录失效
                        $public.message('账号密码错误', 'error');
                    } else {
                        $public.warning('登录状态过期，请重新登录！', { okText: '确定' })
                            .then(res => {
                                $loginOut.loginOutHref();
                            });
                    }
                } else {
                    // 网关错误处理
                    if (options.isMessage) $public.message(res.message, 'error');
                    return resolve(null);
                }
            })
            .catch(err => {
                if (options.isLoading) $public.loading(false);

                if (err.response && err.response.status === 401) {

                    // eslint-disable-next-line no-restricted-globals
                    if (location.hash.indexOf('#/login') >= 0 || location.hash === '#/') {
                        //登录失效
                        $public.message(err.response.data.msg || '账号密码错误', 'error');
                    } else {
                        //退出到平台登录界面
                        $public.warning('登录状态过期，请重新登录！', { okText: '确定' })
                            .then(res => {
                                $loginOut.loginOutHref();
                            });
                    }
                    return resolve(null);
                }
                //网络请求错误处理
                if (options.isMessage) $public.message(err.message || 'Network error！', 'error');
                //保证程序正常运行
                return resolve(null);
            })
    })
}


/**
 * 当前方法只用于部分静态资源请求，没有token，不走网关
 * params: 为完整的axios的request方法参数对象
 */
export const $htp = (params) => {
    return new Promise((resolve) => {
        axios
            .request(params)
            .then(res => {
                return resolve(res);
            })
            .catch(() => {
                //网络请求错误处理
                $public.message('Network error！', 'error');
                //保证程序正常运行
                return resolve(null);
            })
    })
}


//文件导出时， 处理文件名
const getFileName = (res) => {
    let _dis = res.headers['content-disposition'] || res.headers['Content-Disposition'] || res.headers['Content-disposition'];
    return (_dis && _dis.substr(_dis.indexOf('filename=') + 9)) || (_dis && _dis.substr(_dis.indexOf('fileName=') + 9)) || null;
};
//文件导出时， 处理文件类型
const getFileType = (fileName) => {
    const _type = fileName.substr(fileName.indexOf('.') + 1);
    return CONFIG.exportFileType[_type] + '; charset=utf-8';
};
//文件导出时， 处理文件类型
const exportFile = (res) => {
    const _fname = decodeURIComponent(getFileName(res)).replaceAll('"', '');

    if (!_fname || _fname === 'null') {
        const reader = new FileReader();
        reader.readAsText(res.data, 'utf-8');
        reader.onload = function () {
            try {
                const _data = JSON.parse(reader.result);
                $public.message(_data.msg || '系统错误', 'error');
            } catch (error) {
                $public.message('Network error！', 'error');
            }
        }
        return false;
    }

    //转数据
    const _type = getFileType(_fname);
    const _blob = new Blob([res.data], {
        type: _type
    });
    FileSaver.saveAs(_blob, _fname);
    return true;
};


$http.get = function(url, params, options) {
    return $http('GET', url, {}, params, options);
}

$http.put = function(url, data, params, options) {
    return $http('PUT', url, data, params, options);
}

$http.post = function(url, data, params, options) {
    return $http('POST', url, data, params, options);
}

$http.delete = function(url, data, params, options) {
    return $http('DELETE', url, data, params, options);
}

export default $http;
